import { data } from "./../../components/charts/pie-chart/PieChart";
import { IPagination, ISearch } from "../../data/AppInterface";
import { TReactSetState, TSetPaginationFn } from "../../data/AppType";
import { IMediaItemImage } from "../../screens/blog-post/trainer-create-blog-post/TrainerCreateBlogPost";
import {
  GET_ALL_INSIGHTS,
  GET_ALL_INSIGHTS_BY_ID,
  GET_ALL_INSIGHTS_CATEGORY_PUBLIC,
} from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  generatePaginationFromApiRes,
  resetPaginationWithPpr,
  sweetAlertError,
  toastError,
} from "../../utils/AppFunctions";
import { IInsightsDetail } from "../insights-in-use/InsightsController";

export interface IInsights {
  id: number;
  blog_title: string;
  blog_meta_title: string;
  blog_content: string;
  slug: string;
  published: string;
  publish_date?: Date;
  expiry_date?: Date;
  blog_categories: number[];
  post_anonymously: string;
  cover_image: string;
  hash_tags: string[];
  app_media: IMediaItemImage[];
  is_active?: string;
  blog_tags?: string[];
  blog_liked?: string;
  total_reviews?: string;
  created_date?: Date;
  created_by?: string;
}

export interface IInsightsCategory {
  id: number;
  category_title: string;
  category_meta_title: string;
  parent_category_id?: number;
  slug: string;
  is_active?: string;
  deleted?: string;
}
export const fetchInsightsApiCall = async (
  setInsightsList: TReactSetState<IInsights[]>,
  setPagination: TSetPaginationFn,
  pagination: IPagination,
  insights: IInsights[],
  setLoading: TReactSetState<boolean>,
  setBuffer: TReactSetState<boolean>,
  search: ISearch,
  id: number,
  append: boolean
) => {
  try {
    if (!insights) setLoading(true);
    else {
      setBuffer(true);
      const blogList = await GET_ALL_INSIGHTS(pagination, { id, search });
      if (blogList && blogList.code === DEFAULT_STATUS_CODE_SUCCESS) {
        if (append) {
          setInsightsList([...insights, ...blogList?.data?.item]);
        } else setInsightsList(blogList?.data?.item);
        setPagination({
          ...pagination,
          ...generatePaginationFromApiRes(blogList.data.pagination),
        });
      } else {
        setInsightsList([]);
        setPagination({
          ...pagination,
          ...resetPaginationWithPpr(pagination.per_page_rows),
        });
      }
    }
  } catch (e: any) {
    toastError(e?.blogList?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
  } finally {
    setLoading(false);
    setBuffer(false);
  }
};

export const fetchBlogById = async (
  id: number | undefined,
  setBlogsFormInitialValues: TReactSetState<IInsightsDetail | undefined>
) => {
  try {
    if (id) {
      const blogById = await GET_ALL_INSIGHTS_BY_ID(id);
      if (blogById && blogById.code === DEFAULT_STATUS_CODE_SUCCESS) {
        setBlogsFormInitialValues(blogById.data);
      } else {
        sweetAlertError(blogById?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
      }
    }
  } catch (e: any) {
    sweetAlertError(e?.blogById?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
  }
};
